import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import qs from 'qs';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Search from '../../search/Search';
import { receptionFilters } from '../../search/filters';
import {
  getCommand,
  addCheckedCommandId,
  removeCheckedCommandId
} from '../../commandsActions';
import commandState from '../../commandStates';

import EnhancedTableHead from './EnhancedTableHead';
import CommandTableLoader from './CommandTableLoader';
import CoursePaper from '../../../course/CoursePaper';
import unknownCarrierIcon from '../../../../img/unknown-carrier.svg';

const CustomLink = styled.a`
  color: #0000ee;
  text-decoration: none;
`;

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3)
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: 'auto'
  }
});

/**
 * Tableau d'affichage de toutes les commandes dans la partie
 * réceptions
 * @param {Object} classes                        classes style
 * @param {{Object[]}} commands                   Liste des commandes reçu du serveur
 * @param {Number} numberOfCommands               Nombre totale de commande
 * @param {Boolean} loading                       Indique si les requêtes sont terminer
 * @param {Function} dispatchGetCommand           Récupération d'une seul commande via sont id
 */
const EnhancedTable = ({
  classes,
  searchCommands,
  numberOfCommands,
  loading,
  dispatchGetCommand,
  currentCourse
}) => {
  const { search } = useLocation();
  const history = useHistory();

  const initParams = {
    recipientCompany: 'mine'
  };

  const handleChangePage = (event, currentPage) => {
    history.replace({
      search: qs.stringify({
        ...qs.parse(search, { ignoreQueryPrefix: true }),
        page: +currentPage + 1
      })
    });
  };

  return (
    <div>
      <Search initParams={initParams} filters={receptionFilters} />
      <Slide
        direction="right"
        in={!!currentCourse}
        mountOnEnter
        unmountOnExit
        timeout={{ enter: 300, exit: 250 }}
      >
        <div style={{ marginTop: 20 }}>
          <CoursePaper />
        </div>
      </Slide>
      <Paper className={classes.root}>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead rowCount={numberOfCommands} loading={loading} />
            {loading ? (
              <CommandTableLoader />
            ) : (
              <TableBody>
                {searchCommands.map(command => (
                  <TableRow
                    hover
                    style={{ cursor: 'pointer' }}
                    tabIndex={-1}
                    key={command.id}
                  >
                    <TableCell
                      align="left"
                      onClick={() => dispatchGetCommand(command.id)}
                    >
                      {`${command.recipientFirstname} ${
                        command.recipientLastname
                      }`}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => dispatchGetCommand(command.id)}
                    >
                      {`${command.sender.firstname} ${command.sender.lastname}`}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => dispatchGetCommand(command.id)}
                    >
                      {command.recipientAddress.street}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => dispatchGetCommand(command.id)}
                    >{`${
                      commandState[command.state]
                        ? commandState[command.state]
                        : 'N/A'
                    }`}</TableCell>
                    <TableCell align="left">
                      {command.trackingUrl ? (
                        <CustomLink href={command.trackingUrl} target="_blank">
                          {command.trackingNumber}
                        </CustomLink>
                      ) : (
                        command.trackingNumber
                      )}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={() => dispatchGetCommand(command.id)}
                    >
                      {command.finalCarrier ? (
                        command.finalCarrier.name
                      ) : (
                        <img
                          src={unknownCarrierIcon}
                          alt="unknownCarrierIcon"
                          width="40"
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>
        </div>
        <TablePagination
          disabled
          rowsPerPageOptions={[10]}
          component="div"
          count={numberOfCommands || 10}
          rowsPerPage={8}
          page={+qs.parse(search, { ignoreQueryPrefix: true }).page - 1}
          backIconButtonProps={{
            disabled:
              loading ||
              +qs.parse(search, { ignoreQueryPrefix: true }).page === 1,
            'aria-label': 'Previous Page'
          }}
          nextIconButtonProps={{
            disabled:
              loading ||
              +qs.parse(search, { ignoreQueryPrefix: true }).page >
                numberOfCommands / 8 - 1,
            'aria-label': 'Next Page'
          }}
          onChangePage={handleChangePage}
        />
      </Paper>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchGetCommand: commandId => dispatch(getCommand(commandId)),
  dispatchAddCheckedCommandId: commandId =>
    dispatch(addCheckedCommandId(commandId)),
  dispatchRemoveCheckedCommandId: commandId =>
    dispatch(removeCheckedCommandId(commandId))
});

const mapStateToProps = state => ({
  searchCommands: state.commands.searchCommands,
  numberOfCommands: state.commands.numberOfCommands,
  loading: state.commands.loading,
  updateCommandWatch: state.commands.updateCommandWatch,
  courseWatch: state.course.courseWatch,
  mergeCommandWatch: state.mergeCommands.mergeCommandWatch,
  currentCourse: state.init.currentCourse,
  checkedCommandsIds: state.commands.checkedCommandsIds
});

EnhancedTable.propTypes = {
  currentCourse: PropTypes.object,
  classes: PropTypes.object.isRequired,
  searchCommands: PropTypes.array.isRequired,
  numberOfCommands: PropTypes.number,
  dispatchGetCommand: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(EnhancedTable));
